import { CategoriesBannerWithLoader } from './loaders';

export const BannerCategories = () => <CategoriesBannerWithLoader />;
